import React, { useState } from 'react';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface LanguageSelectProps {
    value: string;
    onChange: (language: string) => void;
}

export default function LanguageSelect({ value, onChange }: LanguageSelectProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelect = (lang: string) => {
        onChange(lang);
        handleClose();
    };

    return (
        <Box>
            <Button
                onClick={handleClick}
                startIcon={<TranslateIcon sx={{ fontSize: 18 }} />}
                endIcon={<ExpandMoreIcon sx={{ fontSize: 18 }} />}
                sx={{
                    color: 'var(--text-primary)',
                    textTransform: 'uppercase',
                    fontWeight: 600,
                    fontSize: '13px',
                    fontFamily: 'Inter',
                    borderRadius: '20px',
                    padding: '6px 16px',
                    background: 'rgba(255, 255, 255, 0.65)',
                    backdropFilter: 'blur(16px)',
                    border: '1px solid rgba(74, 107, 44, 0.1)',
                    boxShadow: '0 2px 8px rgba(74, 107, 44, 0.05)',
                    transition: 'all 0.2s',
                    '&:hover': {
                        background: 'rgba(255, 255, 255, 0.95)',
                        boxShadow: '0 4px 12px rgba(74, 107, 44, 0.1)',
                    }
                }}
            >
                {value}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        mt: 1,
                        borderRadius: '12px',
                        border: '1px solid rgba(74, 107, 44, 0.1)',
                        boxShadow: '0 4px 20px rgba(74, 107, 44, 0.1)',
                        minWidth: '140px',
                        padding: '4px'
                    }
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem 
                    onClick={() => handleSelect('en')}
                    sx={{ 
                        borderRadius: '8px',
                        fontSize: '14px', 
                        fontFamily: 'Inter', 
                        fontWeight: value === 'en' ? 600 : 400,
                        color: value === 'en' ? 'var(--accent-color)' : 'var(--text-secondary)',
                        bgcolor: value === 'en' ? 'rgba(74, 107, 44, 0.08)' : 'transparent',
                        mb: 0.5,
                        '&:hover': { bgcolor: 'rgba(74, 107, 44, 0.05)' }
                    }}
                >
                    English (EN)
                </MenuItem>
                <MenuItem 
                    onClick={() => handleSelect('vi')}
                    sx={{ 
                        borderRadius: '8px',
                        fontSize: '14px', 
                        fontFamily: 'Inter', 
                        fontWeight: value === 'vi' ? 600 : 400,
                        color: value === 'vi' ? 'var(--accent-color)' : 'var(--text-secondary)',
                        bgcolor: value === 'vi' ? 'rgba(74, 107, 44, 0.08)' : 'transparent',
                        '&:hover': { bgcolor: 'rgba(74, 107, 44, 0.05)' }
                    }}
                >
                    Tiếng Việt (VI)
                </MenuItem>
            </Menu>
        </Box>
    );
}
